import React from "react";
import _ from "lodash";
import {FormControl, FormHelperText} from "@mui/material";
import {Controller} from "react-hook-form";
import {DatePicker} from '@mui/x-date-pickers';
import {DateTime} from "luxon";

export default function DateView(
  {
    errors = {},
    control,
    name,
    variant = "standard",
    fullWidth = true,
    label,
    items = {},
    margin,
    onBlur,
    ...props
  },
) {
  const error = _.get(errors, name);

  return (
    <FormControl
      fullWidth={fullWidth}
      margin={margin}
      error={!!error}
      onBlur={onBlur}
    >
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({field: {onChange, value, ref, ...field}}) => {
          let parsedValue;
          try {
            parsedValue = DateTime.fromISO(value);
            if (parsedValue?.invalid) {
              parsedValue = undefined;
            }
          } catch(e) {
            parsedValue = undefined;
          }

          return (
            <DatePicker
              label={label}
              inputProps={{
                id: name,
              }}
              format="yyyy-MM-dd"
              cancelText="Abbrechen"
              mask="____-__-__"
              slotProps={{textField: {variant}}}
              inputRef={ref}
              onChange={(date, value) => {
                try {
                  date = date.toISODate();
                } catch (e) {
                  // value = null;
                }
                return onChange(date, value);
              }}
              {...props}
              defaultValue={parsedValue}
              {...field}
            />
          );
        }}
      />
      {error ? <FormHelperText>{error.message}</FormHelperText> : null}
    </FormControl>
  );
}
